import React from "react";

export const getChildrenOnDisplayName = (children: any, displayName: string) => {
  return React.Children.map(children, (child) => {
    return child.type?.displayName === displayName ? child : null;
  });
};
